import EventList from './EventList';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

EventList.schema = schema;
EventList.defaultProps = getEmptyDefaultProps(schema.templateSettings);

// https://github.com/webpack/webpack/issues/706
export default EventList;
